<template>
    
    <inertia-head :title="title ? __(title) + ' - ' + $page.props.app.name : $page.props.app.name">
        <slot />
    </inertia-head>
    
</template>

<script>
    export default {
        components: {
        },
        props: {
            title: String,
        },
    }
</script>